/* Label access for navigation anchors.
   =====================================================================
   A navigation item can carry an icon before its text: Ghost's own
   navigation icons (Ghost 6.59+, the `navigationIcons` labs flag) render as
   <img class="nav-icon"> from partials/nav-link-body.hbs, and the label
   lives in <span class="nav-label">. Every read or rewrite of a label in
   header-nav.js goes through here, so a `textContent` write can never delete
   an icon and an icon can never be mistaken for a label.

   Backward compatibility is the second job: a site that overrode
   partials/navigation.hbs itself may render anchors with NO label span. For
   those, the anchor is the label node, as it was for the 1.5.x script. */

/** The element whose text IS the label: the `.nav-label` span when the markup
 *  has one, otherwise the element itself. */
export function labelNodeOf(el) {
  return el.querySelector('.nav-label') || el;
}

/** The item's icon, or null. Only a DIRECT child with the contract class
 *  counts: an image somewhere inside the label is content, not an icon. */
export function iconNodeOf(el) {
  return el.querySelector(':scope > .nav-icon');
}

/** The item's name as a reader hears it: the label text, or, for an
 *  icon-only item (Ghost sets label to null), the image's alt. Markers are
 *  NOT stripped here; callers own that. Empty string for null. */
export function readLabel(el) {
  if (!el) return '';
  const text = labelNodeOf(el).textContent.trim();
  if (text) return text;
  const icon = iconNodeOf(el);
  return icon && icon.tagName === 'IMG' ? (icon.getAttribute('alt') || '').trim() : '';
}

/** Rewrite ONLY the label text through `strip`, so sibling elements (the
 *  icon) survive. An icon-only item has an icon and no label span, so there
 *  is nothing to strip, and a rewrite would delete its only content. */
export function stripMarkerInPlace(el, strip) {
  const node = labelNodeOf(el);
  if (node === el && iconNodeOf(el)) return;
  node.textContent = strip(node.textContent);
}
